module.exports = __webpack_public_path__ + "img/vip_publicwhite_icon.6cc8b1d1.png";